import { Auth } from 'aws-amplify';
import cx from 'classnames';
import { useDispatch } from 'react-redux';

import { IdentityProvider, UserActionType } from 'types';
import { callbackTriggersActions } from 'store/slices/callbackTriggers';
import { useRouter } from 'hooks';
import { FacebookCircleLogoIcon, GoogleLogoIcon, PhoneIcon } from 'components/Icon';

import styles from './LiveEvent.Login.module.scss';

export type LoginProps = {
  onAuthorize?(): void;
};

const Login = ({ onAuthorize }: LoginProps): JSX.Element => {
  const dispatch = useDispatch();
  const router = useRouter();

  const handleOnSignInWithFacebook = () => {
    onAuthorize?.();

    // TODO: investigate amplify types
    // @ts-ignore
    Auth.federatedSignIn({ provider: IdentityProvider.FACEBOOK });
  };

  const handleOnSignInWithGoogle = () => {
    onAuthorize?.();

    // TODO: investigate amplify types
    // @ts-ignore
    Auth.federatedSignIn({ provider: IdentityProvider.GOOGLE });
  };

  const handleOnSignInWithPhone = () => {
    dispatch(
      callbackTriggersActions.set([
        { type: UserActionType.RAISE_HAND },
        { type: UserActionType.REDIRECT, payload: { path: router.pathname } }
      ])
    );

    router.push('/login');
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.message}>Please, log in to continue. Choose one of the options below</h3>
      <div className={styles.actions}>
        <button type="button" className={cx(styles.action, styles.google)} onClick={handleOnSignInWithGoogle}>
          <GoogleLogoIcon />
          <span>Continue with Google</span>
        </button>
        <button type="button" className={cx(styles.action, styles.facebook)} onClick={handleOnSignInWithFacebook}>
          <FacebookCircleLogoIcon />
          <span>Continue with Facebook</span>
        </button>
        <button type="button" className={cx(styles.action, styles.phone)} onClick={handleOnSignInWithPhone}>
          <PhoneIcon />
          <span>Continue with phone number</span>
        </button>
      </div>
    </div>
  );
};

export default Login;
